/**
 * ID for the Facebook marketing retailer pixel
 */
export const FACEBOOK_RETAILER_PIXEL_ID = 'FACEBOOK_RETAILER_PIXEL_ID';
